import { EventEmitter } from '@root/Services/EventEmitter';
import { singleton } from 'tsyringe';
import { Company } from '@apis/Customers/model';

@singleton()
export class SiteMenuCompanyService {
    public rootCompany = new EventEmitter<Company | undefined>(undefined);
    public company = new EventEmitter<Company | undefined>(undefined);
}
